import { buildSelectionKey } from './selectionKey';

const toSelectionEntry = (item) => {
  const masterProductId = item.masterProductId
    || item.listingProduct?.masterProductId
    || item.baseProduct?.masterProductId;

  return {
    key: buildSelectionKey(item),
    type: item.type,
    _id: item._id,
    baseProductId: item.baseProductId || item.productId,
    sku: item.sku,
    title: item.title,
    channelId: item.channelId || item.salesChannelId,
    listingStatus: item.listingStatus,
    ...(masterProductId ? { masterProductId } : {}),
    ...(item.masterVariantId != null ? { masterVariantId: item.masterVariantId } : {}),
    ...('live' in item ? { live: item.live } : {}),
    ...('draftBaseline' in item ? { draftBaseline: item.draftBaseline } : {}),
  };
};

export const toMasterProductEntry = (product) => toSelectionEntry({
  type: 'master',
  _id: product._id,
  sku: product.sku,
  title: product.title,
});

export const toMasterVariantEntry = (variant) => toSelectionEntry({
  type: 'masterVariant',
  _id: variant._id,
  baseProductId: variant.baseProductId || variant.productId,
  sku: variant.sku,
  title: variant.title,
});

export default toSelectionEntry;
